import { useTranslation } from "react-i18next";
import "./MedilinkInfoCard.css";

export default function MedilinkInfoCard() {
  const { t } = useTranslation();

  return (
    <div className="medilink-info-card">
      <div className="info-links-grid">
        <a href="#" className="info-link">
          {t("medilinkInfo.infos")}
        </a>
        <a href="#" className="info-link">
          {t("medilinkInfo.accessibility")}
        </a>
        <a href="#" className="info-link">
          {t("medilinkInfo.support")}
        </a>
        <a href="#" className="info-link">
          {t("medilinkInfo.terms")}
        </a>
        <a href="#" className="info-link">
          {t("medilinkInfo.adsPreferences")}
        </a>
        <a href="#" className="info-link">
          {t("medilinkInfo.advertising")}
        </a>
        <a href="#" className="info-link">
          {t("medilinkInfo.businessSolutions")}
        </a>
        <a href="#" className="info-link">
          {t("medilinkInfo.downloadApp")}
        </a>
        <a href="#" className="info-link">
          {t("medilinkInfo.more")}
        </a>
      </div>

      <div className="copyright-section">
        <span className="medilink-brand">Medilink</span>
        <span className="copyright-text">
          {t("medilinkInfo.copyright")}
        </span>
      </div>
    </div>
  );
}
